import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import DatePicker from "react-datepicker"; 
import "react-datepicker/dist/react-datepicker.css";
import "react-datetime/css/react-datetime.css";
import { Typeahead } from 'react-bootstrap-typeahead';
import { format } from 'date-fns';

import {aflt_departmentsListAction} from '../../../actions/settings/affiliates/aflt_departmentActions';
import CustomMultiSelect from '../../../components/commons/helpers/customMultiSelect';

import { LBL_QUOTE_EVENT_CANCEL_REASONS,LBL_DEPARTMENTS,LBL_CLIENT, LBL_EVENT, LBL_LOCATION, LBL_TITLE, LBL_EVENT_STATUS, LBL_QUOTE_STATUS, LBL_DATE_FROM, LBL_DATE_TO, LBL_CREATED_COMPLETED_DATE, LBL_CREATED_DATE, LBL_SELECT, LBL_COMPLETED_DATE, LBL_STARTED_DATE, LBL_AFFILIATE, LBL_CHOOSE_CLIENT, LBL_CHOOSE_AFFILIATE, LBL_EVENT_STAFF_ASSIGNED_STATUS, LBL_ALL, LBL_COMPLETED, LBL_INCOMPLETE } from '../../../configs/labelConfigs'; // LBL_EVENT_START_DATE_FROM
import { EVENT_STATUS_CANCELLED,QUOTE_STATUS, EVENT_STATUS, EVENT_STATUS_ESTIMATION, EVENT_STATUS_QUOTE_REQUESTED, EVENT_STATUS_QUOTE_SENT, EVENT_STATUS_QUOTE_DECLINED, EVENT_STATUS_REESTIMATION, LOGIN_SUPER_ADMIN_GROUP, QUOTE_STATUS_ESTIMATION, QUOTE_STATUS_REQUESTED, QUOTE_STATUS_SENT, QUOTE_STATUS_DECLINED, QUOTE_STATUS_REESTIMATION} from '../../../configs/staticConfigs';

import { getUserGroupData } from '../../../utils/browserStorage';
import {titleCase} from '../../../utils/changeCase';
import {filterClientsListAction,eventsFilterEventsListAction,eventsFilterLocationsListAction,filterAffiliatesListAction} from '../../../actions/eventActions'; 
import * as types from '../../../actions';
import { serverTimeAction, fromActionRequired, fromClientDashboardQuotes, fromClientDashboardEvents, fromClientDashboardCompletedEvents,fromDashboardShiftTimeChange} from '../../../actions/commonActions';

let eventStatusData = [];
let eventStatusDataMaster = [];
let quotePageEventStatusData = [];
let quotePageEventStatusDataMaster = [];
let arrQuoteEventsStatus = [EVENT_STATUS_CANCELLED,EVENT_STATUS_ESTIMATION, EVENT_STATUS_QUOTE_REQUESTED, EVENT_STATUS_QUOTE_SENT, EVENT_STATUS_QUOTE_DECLINED, EVENT_STATUS_REESTIMATION]; 
EVENT_STATUS.forEach(item => { 
    if(Number(item.statusCode)!==Number(EVENT_STATUS_ESTIMATION)) {
        eventStatusData.push({value:item.statusCode,label:item.statusString}); 
        eventStatusDataMaster.push({value:item.statusCode,label:item.statusString});
    }
    if(arrQuoteEventsStatus.includes(Number(item.statusCode))) {
        quotePageEventStatusData.push({value:item.statusCode,label:item.statusString}); 
        quotePageEventStatusDataMaster.push({value:item.statusCode,label:item.statusString}); 
    }
});
 
let quoteStatusData = [];
let eventPageQuoteStatusData = [];
let arrQuoteStatus = [QUOTE_STATUS_ESTIMATION, QUOTE_STATUS_REQUESTED, QUOTE_STATUS_SENT, QUOTE_STATUS_DECLINED, QUOTE_STATUS_REESTIMATION]; 
QUOTE_STATUS.forEach(item => {
    if(item.statusCode !== '7')
        eventPageQuoteStatusData.push({value:item.statusCode,label:item.statusString}); 
    if(arrQuoteStatus.includes(Number(item.statusCode))) {
        quoteStatusData.push({value:item.statusCode,label:item.statusString}); 
    }
    //if(Number(item.statusCode)!==Number(QUOTE_STATUS_ACCEPTED)) { }
});


class FilterEvent extends Component {
    
    constructor(props){
        super(props)
        this.state = { 
            isSAPage: this.props.userGroup &&  Number(this.props.userGroup)===Number(LOGIN_SUPER_ADMIN_GROUP) ? Number(this.props.userGroup) : 0,
            clientListCalled: 0, 
            departmentsList:[],
            deptMultiSelList:[],
            selectedDepartments:[],
            selectedAffiliateId: 0,   
            selectedAffiliate: [],   
            affiliatesOptions: [],

            selectedClientId: this.props.clientId?this.props.clientId:0,   
            selectedClient: this.props.clientId?[{id:this.props.clientId, name:''}] : [],   
            clientsOptions: [],

            selectedEventId: 0, 
            selectedEvent: [], 
            eventsOptions: [], 

            selectedLocId: 0, 
            selectedLocation: [],
            locationsOptions: [], 

            eventStatusIds: [],
            quoteStatusIds: [], 
            includeDate: false, 
            selectedStartDate: new Date(),
            defaultStartDate: new Date(),
            selectedEndDate: new Date(),
            defaultEndDate: new Date(),
            resetFilterClicked: 0,
            applyFilterClicked: 0,
            selDateType: '',
            shiftTimeChangeRequest:false,
            eventListAdded:false,
            eventStatusData:[],
            cancelReasonsData:[],
            selectedCancelReasons:[],
            enableCancelReason:false,
            selStaffAssigned: ''
        }
    }

    onSelectCCDate = (e) => {
        let includeDate = false; 
        if(e.target.value.length > 1) includeDate = true; 
        this.setState({selDateType:e.target.value,includeDate}) 
    } 

    onSelectStaffAssigned = (e) => {
        this.setState({selStaffAssigned:e.target.value}) 
    } 

    onEventStatusDataChange = (selectedStatus,selType) =>{
        let selStatus = [];
        let enableCancelReason = false;
        let selectedCancelReasons = this.state.selectedCancelReasons;
        let cancelReasonsData = this.state.cancelReasonsData;
        selectedStatus.forEach((item) => {
            selStatus.push(parseInt(item.value,10));
        });
        if(selStatus.indexOf(8) > -1){
            enableCancelReason = true;
            cancelReasonsData.map((item,index)=>{
                item.checkDisable = false;
                return item
            })
        }else{
            cancelReasonsData.map((item,index)=>{
                item.inputVal = 0;
                item.checkDisable = true;
                return item
            })
            selectedCancelReasons = [];
        }
        if(selType==='event')  this.setState({eventStatusIds:selStatus,cancelReasonsData:cancelReasonsData,selectedCancelReasons:selectedCancelReasons,enableCancelReason:enableCancelReason});
        else if(selType==='quote')  this.setState({quoteStatusIds:selStatus,cancelReasonsData:cancelReasonsData,selectedCancelReasons:selectedCancelReasons,enableCancelReason:enableCancelReason});
    }

    onShiftTimeChangeRequestChecked = (e) =>{
       const value  = e.target.checked;
       this.setState({shiftTimeChangeRequest:value});

    }

    handleLocationChange = (selectedLocation) => {
        let locId = 0; 
        let selLoc = []; 
        if(selectedLocation.length>0){
            selLoc = selectedLocation; 
            locId = selectedLocation[0].id; 
        } 
        this.setState({selectedLocation:selLoc, selectedLocId:locId});  
    }
    
    handleRemoveLocation = (e) => {
    }

    getSelectedAffiliates = () => {
        let arrAfltIds = []
        if(this.state.isSAPage > 0 && this.state.selectedAffiliate && this.state.selectedAffiliate.length) {
            this.state.selectedAffiliate.forEach(item => {
                arrAfltIds.push(item.id)
            }) 
        }
        return arrAfltIds; 
    }

    getSelectedClients = () => {
        let arrClientIds = []
        if(this.state.selectedClient && this.state.selectedClient.length) {
            this.state.selectedClient.forEach(item => {
                arrClientIds.push(item.id)
            }) 
        }
        return arrClientIds; 
    }

    handleAffiliateChange = (selAffiliate) => {
        let afltId = 0; 
        let selAflt = []; 
        if(selAffiliate.length>0){
            selAflt = selAffiliate; 
            afltId = selAffiliate[0].id; 
            let dataObj = {isEvent:this.props.isEvent, affiliateIds:[afltId]}; 
            this.props.filterClientsListAction(dataObj); 
            this.props.eventsFilterEventsListAction(dataObj); 
            this.props.eventsFilterLocationsListAction(dataObj);
            this.props.aflt_departmentsListAction({affiliateId: afltId})
        }else{
            this.setState({deptMultiSelList:[]});
        }
        this.setState({selectedAffiliate:selAflt, selectedAffiliateId:afltId});   
    }

    handleRemoveAffiliate = (e) => { 
        if(e==='') {
            let dataObj = {isEvent:this.props.isEvent}; 
            this.props.filterClientsListAction(dataObj);
            this.props.eventsFilterEventsListAction(dataObj); 
            this.props.eventsFilterLocationsListAction(dataObj); 
        }
    }

    handleClientChange = (selectedClient) => {
        let clId = 0; 
        let selClient = []; 
        if(selectedClient.length>0){
            selClient = selectedClient; 
            clId = selectedClient[0].id; 
            let dataObj = {}; 
            if(this.state.isSAPage > 0) {
                let arrAflt = this.getSelectedAffiliates(); 
                dataObj = {isEvent:this.props.isEvent, clientsIds:[clId], affiliateIds:arrAflt}; 
            }
            else {
                dataObj = {isEvent:this.props.isEvent, clientsIds:[clId]}; 
            }
            this.props.eventsFilterEventsListAction(dataObj); 
            this.props.eventsFilterLocationsListAction(dataObj); 
        } 
        this.setState({selectedClient:selClient, selectedClientId:clId});  
    }
    
    handleRemoveClient = (e) => { 
        if(e==='') {
            let dataObj = {};
            if(this.state.isSAPage > 0) {
                let arrAflt = this.getSelectedAffiliates();  
                dataObj = {isEvent:this.props.isEvent, affiliateIds:arrAflt}; 
            }
            else {
                dataObj = {isEvent:this.props.isEvent}; 
            }
            this.props.eventsFilterEventsListAction(dataObj); 
            this.props.eventsFilterLocationsListAction(dataObj); 
        } 
    }

    handleEventChange = (selectedEvent) => {
        let eventId = 0; 
        let selEvent = []; 
        if(selectedEvent.length>0){
            selEvent = selectedEvent; 
            eventId = selectedEvent[0].id; 
            let dataObj = {isEvent:this.props.isEvent}; 
            if(this.props.clientId && this.props.clientId > 0) {
                let storageData = getUserGroupData('client'); 
                dataObj = {isEvent:this.props.isEvent, affiliateIds:[Number(storageData.client_default_affiliate_id)],eventIds:[eventId]}; 
                this.props.eventsFilterLocationsListAction(dataObj);
            }
            else {
                let arrClientIds = this.getSelectedClients(); 
                let arrAflt = this.getSelectedAffiliates();
                dataObj = {isEvent:this.props.isEvent, affiliateIds:arrAflt, clientsIds:arrClientIds, eventIds:[eventId]}; 
            }

            this.props.eventsFilterLocationsListAction(dataObj);
        } 
        this.setState({selectedEvent:selEvent, selectedEventId:eventId});  
    }

    onCancelReasonDataChange = (selected) =>{
        let selCanRe = []; 
        if(selected.length>0){
            selected.map((item,index)=>{
                selCanRe.push(parseInt(item.value))
            })
        }
        this.setState({selectedCancelReasons:selCanRe})
    }
    
    handleRemoveEvent = (e) => {
        if(e==='') {
            if(this.props.clientId && this.props.clientId > 0) {
                let storageData = getUserGroupData('client'); 
                let dataObj = {isEvent:this.props.isEvent, affiliateIds:[Number(storageData.client_default_affiliate_id)]}; 
                this.props.eventsFilterLocationsListAction(dataObj);
            }
            else {
                let arrAflt = this.getSelectedAffiliates();
                let dataObj = {isEvent:this.props.isEvent, affiliateIds:arrAflt};
                this.props.eventsFilterLocationsListAction(dataObj); 
            }
            
        } 
    }

    handleRemoveLocation = (e) => {
    }
    
    onStartDateChange = (date) =>{
        let startDate = new Date(date);
        
        if(this.state.selectedEndDate < startDate) {
            this.setState({selectedStartDate:startDate,selectedEndDate:startDate});    
        }
        else {
            this.setState({selectedStartDate:startDate});    
        }
    }

    onEndDateChange = (date) =>{ 
        let endDate = new Date(date);
        this.setState({selectedEndDate:endDate});  
    }

    resetFilters = () => { 
        quoteStatusData = []; // TO RESET MULTISEL VALUES 
        eventPageQuoteStatusData = []; 
        eventStatusData = [];
        quotePageEventStatusData = []; 

        this.setState({ 

            selectedAffiliateId: 0,   
            selectedAffiliate: [],   
            
            selectedClientId: 0,   
            selectedClient: [],   

            selectedEventId: 0, 
            selectedEvent: [], 

            selectedLocId: 0, 
            selectedLocation: [],

            eventStatusIds: [],
            quoteStatusIds: [],
            selectedDepartments: [],

            includeDate: false, 
            selectedStartDate: this.state.defaultStartDate,
            selectedEndDate: this.state.defaultEndDate,
            resetFilterClicked: 0,
            applyFilterClicked: 0,
            selDateType:'',
            selStaffAssigned: '', 
            shiftTimeChangeRequest:false,
            eventListAdded:false
        }); 

        // TO RESET MULTISEL VALUES 
        let selItds = [2];
        eventStatusData = eventStatusDataMaster;
        quotePageEventStatusData = quotePageEventStatusDataMaster; 

        // EVENT_STATUS.forEach(item => {
        //     if(Number(item.statusCode)!==Number(EVENT_STATUS_ESTIMATION)) {
        //             eventStatusData.push({value:item.statusCode,label:item.statusString,}); 
        //         }
        // });
        QUOTE_STATUS.forEach(item => {
            if(this.props.dashboardActionRequired && Number(item.statusCode)==Number(EVENT_STATUS_QUOTE_REQUESTED)){
                    quoteStatusData.push({value:item.statusCode,inputVal:1,label:item.statusString,});
                    eventPageQuoteStatusData.push({value:item.statusCode,inputVal:1,label:item.statusString,});
                    this.setState({quoteStatusIds:selItds});
                    this.props.fromActionRequired(false); 
            }else{
                if(item.statusCode !== '7')
                    eventPageQuoteStatusData.push({value:item.statusCode,label:item.statusString,});
                if(arrQuoteStatus.includes(Number(item.statusCode))) {
                    quoteStatusData.push({value:item.statusCode,label:item.statusString}); 
                }
            }
            // if(Number(item.statusCode)!==Number(QUOTE_STATUS_ACCEPTED)) { }
        });
        eventStatusData = [];
        eventStatusDataMaster.map(eventItem => {
            eventStatusData.push({value:eventItem.value,label:eventItem.label})
        });

        
        if(this.props.clientId && this.props.clientId > 0) {
            let storageData = getUserGroupData('client'); 
            let dataObj = {isEvent:this.props.isEvent, affiliateIds:[Number(storageData.client_default_affiliate_id)]}; 
            this.props.eventsFilterEventsListAction(dataObj); 
            this.props.eventsFilterLocationsListAction(dataObj);
        }
        else {
            if(this.state.isSAPage > 0) this.props.filterAffiliatesListAction(); 
            this.props.filterClientsListAction(); 
            let dataObj = {isEvent:this.props.isEvent}; 
            this.props.eventsFilterEventsListAction(dataObj); 
            this.props.eventsFilterLocationsListAction(dataObj);
        }
        this.loadMultiSelDeptValues(); 
    }

    sendFilterData = () => {
        let filtersSelected = 0; 

        let arrAflt = this.getSelectedAffiliates();
        if(arrAflt.length > 0) filtersSelected = 1; 

        let arrClientIds = this.getSelectedClients();
        if(arrClientIds.length > 0) filtersSelected = 1; 

        let arrEventIds = [];
        if(this.state.selectedEvent && this.state.selectedEvent.length) {
            this.state.selectedEvent.forEach(item => {
                if(Number(item.id) > 0) {
                    arrEventIds.push(item.id);
                    filtersSelected = 1; 
                }
            }) 
        }

        let arrLocIds = [];
        if(this.state.selectedLocation && this.state.selectedLocation.length) {
            this.state.selectedLocation.forEach(item => {
                if(Number(item.id) > 0) {
                    arrLocIds.push(item.id);
                    filtersSelected = 1; 
                }
            }) 
        }

        let arrEventStatIds = []; 
        this.state.eventStatusIds.forEach(item => { arrEventStatIds.push(Number(item)); }); 
        if(arrEventStatIds.length) filtersSelected = 1; 

        let arrQuoteStatIds = []; 
        this.state.quoteStatusIds.forEach(item => { arrQuoteStatIds.push(Number(item)); }); 
        if(arrQuoteStatIds.length) filtersSelected = 1; 

        if(this.state.selectedDepartments.length){
            filtersSelected = 1;
            if(this.state.deptMultiSelList.length === this.state.selectedDepartments.length){
                this.state.selectedDepartments.push('all');
            }
        } 
        if(this.state.selectedCancelReasons.length) filtersSelected = 1; 

        let fromDate = 0; 
        let endDate = 0;
        let selDateType = 0; 
        if(this.state.selDateType.length > 1) {
            selDateType = this.state.selDateType; 
            fromDate = format(new Date(this.state.selectedStartDate), 'yyyy-MM-dd');
            endDate = format(new Date(this.state.selectedEndDate), 'yyyy-MM-dd');
            filtersSelected = 1;
        }
        if(this.state.shiftTimeChangeRequest)filtersSelected = 1;
        
        let filterData = {cancelReasons:this.state.selectedCancelReasons,departments:this.state.selectedDepartments,affiliateIds:arrAflt, clientsIds:arrClientIds, eventIds:arrEventIds, locIds:arrLocIds, eventStatIds:arrEventStatIds, quoteStatIds:arrQuoteStatIds, selDateType:selDateType, selectedStartDate:fromDate, selectedEndDate:endDate, filtersSelected:filtersSelected,shiftTimeChangeRequest:this.state.shiftTimeChangeRequest,selStaffAssigned:this.state.selStaffAssigned}; 
        this.props.applyFilters(filterData); 
    }

    loadMultiSelDeptValues() {
        let allDept = []; 
        let selectedDepartments = [];
        if(this.state.departmentsList.length > 0) {
           let tmpObj = {}; 
           let len = this.state.departmentsList.length; 
           let deptId = 0;  
           this.state.departmentsList.forEach((item,index) => { 
              tmpObj = {value:item.id, label:titleCase(item.name), inputVal:1}; 
              allDept.push(tmpObj);
              selectedDepartments.push(item.id) 
           }) 
        }
        this.setState({deptMultiSelList:allDept,selectedDepartments:selectedDepartments},()=>{
                this.sendFilterData()
        });
     }

    handleChangeMultiSel = (selectedDepts) =>{
        let actUserDept = []; 
        selectedDepts.forEach((item) => {
           actUserDept.push(item.value);
        }); 
        this.setState({selectedDepartments:actUserDept}); 
    }
    componentDidMount() {
        this.props.serverTimeAction();
    }
    componentDidUpdate (prevProps) {
        if(this.props.serverTimeListActivity && this.props.serverTimeListActivity !== prevProps.serverTimeListActivity){
            let arrTimeResp = this.props.serverTimeListActivity.split('~~');
            if(arrTimeResp[0]===types.SERVER_TIME_LIST_SUCCESS){
                // let defaultEndDate = new Date(this.props.serverTimeList.current_date+" 00:00:00");
                let defaultEndDate = new Date(this.props.serverTimeList.current_date+"T00:00:00");
                this.setState({defaultStartDate:defaultEndDate,defaultEndDate:defaultEndDate,
                            selectedStartDate:defaultEndDate,selectedEndDate:defaultEndDate})
            }
        } 
        if(this.props.filterClicked!==prevProps.filterClicked && this.state.clientListCalled===0) {
            this.setState({clientListCalled:1}); // TO PREVENT REPEATED API CALLS 
            if(this.state.isSAPage > 0) { // FROM SUPERADMIN LOGIN 
                this.props.filterAffiliatesListAction(); 
                let arrAflt = this.state.selectedAffiliateId > 0 ? [this.state.selectedAffiliateId] : []; 
                let dataObj = {isEvent:this.props.isEvent, affiliateIds:arrAflt};
                this.props.filterClientsListAction(dataObj); 
                let arrClients = this.state.selectedClientId > 0 ? [this.state.selectedClientId] : []; 
                dataObj = {isEvent:this.props.isEvent, affiliateIds:arrAflt, clients:arrClients};
                this.props.eventsFilterEventsListAction(dataObj); 
                this.props.eventsFilterLocationsListAction(dataObj);
            }
            else if(this.props.clientId && this.props.clientId > 0) { // FROM CLIENT LOGIN 
                let storageData = getUserGroupData('client'); 
                let dataObj = {isEvent:this.props.isEvent, affiliateIds:[Number(storageData.client_default_affiliate_id)]}; 
                this.props.eventsFilterEventsListAction(dataObj); 
                this.props.eventsFilterLocationsListAction(dataObj);
            }
            else {
                let dataObj = {isEvent:this.props.isEvent}; 
                this.props.filterClientsListAction(); 
                this.props.eventsFilterEventsListAction(dataObj); 
                this.props.eventsFilterLocationsListAction(dataObj);
                quoteStatusData.map(eventItem => {

                    eventItem.inputVal = 0;
                    return eventItem;
                });
                eventPageQuoteStatusData.map(eventItem => {

                    eventItem.inputVal = 0;
                    return eventItem;
                });
                if(this.props.cancelReasons && this.props.cancelReasons.length > 0){
                    let cancelReasonsData = [];
                    this.props.cancelReasons.map((item,index)=>{
                        cancelReasonsData.push({value:item.id,label:item.name,inputVal:0,checkDisable:true});
                    })
                    this.setState({cancelReasonsData:cancelReasonsData})
                }
            }
        } 



        if(this.props.applyFilterClicked > 0 && this.props.applyFilterClicked!==prevProps.applyFilterClicked && this.state.applyFilterClicked < this.props.applyFilterClicked) {
            this.setState({applyFilterClicked:this.props.applyFilterClicked}); // TO PREVENT REPEATED API CALLS 
            this.sendFilterData(); 
        }

        if(this.props.resetFilterClicked > 0 && this.props.resetFilterClicked!==prevProps.resetFilterClicked && this.state.resetFilterClicked < this.props.resetFilterClicked) {
            this.setState({resetFilterClicked:this.props.resetFilterClicked}); // TO PREVENT REPEATED API CALLS 
            this.resetFilters(); 
        }

        const {depActivity,filterClientsList,eventsFilterStatus,eventsFilterActivity,eventsFilterErrorData,eventsFilterEventsList,eventsFilterLocationsList,filterActivity,filterStatus,filterErrorData,filterAffiliateActivity, filterAffiliatesList} = this.props; 
        if (depActivity && depActivity !== prevProps.depActivity) {
            let arrTmp = [];
            arrTmp = (depActivity && depActivity.length) ? depActivity.split('~~') : [];
            let actString = arrTmp[0]; 
            if(actString===types.DEPARTMENT_LIST_AFFILIATE_SUCCESS) { 
                if(this.props.departmentsList.length===0) {
                      this.setState({departmentsList: []}, () => {
                         this.loadMultiSelDeptValues(); 
                      } ); 
                    }
                else {     
                          this.setState({departmentsList: this.props.departmentsList}, () => {
                             this.loadMultiSelDeptValues(); 
                          } );                  
                    }

            }
        }
        if (filterActivity && filterActivity !== prevProps.filterActivity) {
            let arrTmp = [];
            arrTmp = (filterActivity && filterActivity.length) ? filterActivity.split('~~') : [];
            let actString = arrTmp[0]; 
            if(actString===types.FILTER_CLIENTS_LIST_SUCCESS) { 
                let clientsOptions = [];  
                if(filterStatus===200) {
                    if(filterClientsList && Array.isArray(filterClientsList)){
                        filterClientsList.forEach(item => {  
                            if(item.client_id && item.client_name) {
                                clientsOptions.push({id:item.client_id, name:item.client_name});
                            }           
                        });            
                    }
                }
                else {
                    console.log('Clients List Error '+JSON.stringify(filterErrorData)); 
                }
                this.setState({clientsOptions}); 
            }
            else if(actString===types.FILTER_AFFILIATE_LIST_SUCCESS) { 
                let affiliatesOptions = [];  
                if(filterStatus===200) {
                    if(filterAffiliatesList && Array.isArray(filterAffiliatesList)){
                        filterAffiliatesList.forEach(item => {             
                            affiliatesOptions.push({id:item.id, name:item.company_name});
                        });            
                    }
                }
                else {
                    console.log('Affiliates List Error '+JSON.stringify(filterErrorData)); 
                }
                this.setState({affiliatesOptions}); 
            }
        }

        if (eventsFilterActivity && eventsFilterActivity !== prevProps.eventsFilterActivity) {
            let arrTmp = [];
            arrTmp = (eventsFilterActivity && eventsFilterActivity.length) ? eventsFilterActivity.split('~~') : [];
            let actString = arrTmp[0]; 
            if(actString===types.EVENTS_FILTER_EVENTS_LIST_SUCCESS) { 
                let eventsOptions = [];  
                if(eventsFilterStatus===200) {
                    if(eventsFilterEventsList && Array.isArray(eventsFilterEventsList)){
                        eventsFilterEventsList.forEach(item => {             
                            eventsOptions.push({id:item.event_id, name:item.event_title});
                        });            
                    }
                }
                else {
                    console.log('Events List Error '+JSON.stringify(eventsFilterErrorData)); 
                }
                this.setState({eventsOptions}); 
            }


            if(actString===types.EVENTS_FILTER_LOCATIONS_LIST_SUCCESS) { 
                let locationsOptions = [];  
                if(eventsFilterStatus===200) {
                    if(eventsFilterLocationsList && Array.isArray(eventsFilterLocationsList)){
                        eventsFilterLocationsList.forEach(item => {             
                            locationsOptions.push({id:item.location_id, name:item.location_name});
                        });            
                    }
                }
                else {
                    console.log('Locations List Error '+JSON.stringify(eventsFilterErrorData)); 
                }
                this.setState({locationsOptions}); 
            } 

        }
            
    }

    render(){
        let isEvent = 0;
        if(this.props.isEvent) isEvent = this.props.isEvent;
        let isSAPage = this.state.isSAPage;
        let {selectedAffiliateId, selectedAffiliate, affiliatesOptions, selectedClient,clientsOptions,  selectedEvent,eventsOptions, selectedLocation,locationsOptions, selectedStartDate, selectedEndDate, includeDate, selDateType, selStaffAssigned} = this.state; 
        let paddingTopPix = this.props.isEvent?eventStatusData.length*40:eventPageQuoteStatusData.length*40; // TO GIVE SCROLL SPACE FOR THE EVENT STATUS DROPDOWN 
        if(this.props.fromDashboardShiftTimeChangeRequest){
            this.setState({shiftTimeChangeRequest:true});
            this.props.fromDashboardShiftTimeChange(false);
            this.props.onApplyFilterButton();

            }else if(this.props.fromClientDashboardQuote){
            let new_event = [1,2,3]
            quotePageEventStatusData.map(eventItem => {
                if(eventItem.value == 1 || eventItem.value == 2 || eventItem.value == 3){
                    eventItem.inputVal = 1;
                }else{
                    eventItem.inputVal = 0;
                }
                return eventItem;
            });
            this.setState({eventStatusIds:new_event,eventListAdded:true});
            this.props.fromClientDashboardQuotes(false);
            this.props.onApplyFilterButton();
        }else if(this.props.fromClientDashboardEvent){
            let new_event = [4,6,10]
            eventStatusData.map(eventItem => {

                if(new_event.indexOf(parseInt(eventItem.value)) != -1){
                    eventItem.inputVal = 1;
                }else{
                    eventItem.inputVal = 0;
                }
                return eventItem;
            });
            this.setState({eventStatusIds:new_event,eventListAdded:true});
            this.props.fromClientDashboardEventsFun(false);
            this.props.onApplyFilterButton();
        }else if(this.props.fromClientDashboardCompletedEvent){
            let new_event = [7]
            eventStatusData.map(eventItem => {

                if(new_event.indexOf(parseInt(eventItem.value)) != -1){
                    eventItem.inputVal = 1;
                }else{
                    eventItem.inputVal = 0;
                }
                return eventItem;
            });
            this.setState({eventStatusIds:new_event,eventListAdded:true});
            this.props.fromClientDashboardCompletedEvents(false);
            this.props.onApplyFilterButton();
        }else if(!this.state.eventListAdded){
            let new_event = [1,2,3,4,5,6,10]
            eventStatusData.map(eventItem => {

                if(new_event.indexOf(parseInt(eventItem.value)) != -1){
                    eventItem.inputVal = 1;
                }else{
                    eventItem.inputVal = 0;
                }
                return eventItem;
            });
            quotePageEventStatusData.map(eventItem => {
                if(new_event.indexOf(parseInt(eventItem.value)) != -1){
                    eventItem.inputVal = 1;
                }else{
                    eventItem.inputVal = 0;
                }
                return eventItem;
            });

            this.setState({eventStatusIds:new_event,eventListAdded:true});
            this.props.onApplyFilterButton();
        }
        return(
            <React.Fragment>

                {isSAPage > 0 &&  
                <div className="filter-category">
                    <h4>{LBL_AFFILIATE}</h4> 
                    <div className="form-group">
                        <div className="form-group select-input">
                            <Typeahead
                                selected ={selectedAffiliate}
                                id="affiliates"
                                labelKey="name"
                                options={affiliatesOptions}
                                placeholder={LBL_CHOOSE_AFFILIATE+'...'} 
                                inputProps={{ name:'affiliateId', className:''}}
                                onChange={(s) => this.handleAffiliateChange(s)}
                                onInputChange={this.handleRemoveAffiliate}
                            />  
                        </div>
                    </div>
                </div>}
                {!this.props.isClientPage &&
                <div className="filter-category">
                    <div className="form-group">
                        <h4>{LBL_DEPARTMENTS}</h4>
                        <div className="form-group multisel_textbox">
                                <div className="form-group select-input skills" >
                                <CustomMultiSelect id={'dept'} data={this.state.deptMultiSelList} trimString='yes'  onChange={selected =>this.handleChangeMultiSel(selected)} isTextBox={false} marginTop0='marginTop0' inputProps={{ tabIndex:"10" }} tabIndex="10" needSelectAll={true} />
                                </div>
                        </div> 
                    </div>
                </div>}

                {!this.props.isClientPage &&  
                <div className="filter-category">
                    <h4>{LBL_CLIENT}</h4>
                    <div className="form-group">
                        <div className="form-group select-input">
                            <Typeahead
                                selected ={selectedClient}
                                id="clients"
                                labelKey="name"
                                options={clientsOptions}
                                placeholder={LBL_CHOOSE_CLIENT+'...'} 
                                inputProps={{ name:'clientId', className:''}}
                                onChange={(s) => this.handleClientChange(s)}
                                onInputChange={this.handleRemoveClient}
                            />  
                        </div>
                    </div>
                </div>}

                {this.props.eventTitleNotRequired!=='yes' && <div className="filter-category">
                    <h4>{LBL_EVENT+' '+LBL_TITLE}</h4> 
                    <div className="form-group">
                        <div className="form-group select-input">
                            <Typeahead
                                selected ={selectedEvent} 
                                id="events"
                                labelKey="name"
                                options={eventsOptions}
                                placeholder={"Choose "+LBL_EVENT+"..."}
                                inputProps={{ name:'eventId', className:''}}
                                onChange={(s) => this.handleEventChange(s)}
                                onInputChange={this.handleRemoveEvent}
                            />  
                        </div>
                    </div>
                </div>}
                
                <div className="filter-category">
                    <h4>{LBL_LOCATION}</h4>
                    <div className="form-group">
                        <div className="form-group select-input">
                            <Typeahead
                                selected ={selectedLocation} 
                                id="locations"
                                labelKey="name"
                                options={locationsOptions}
                                placeholder="Choose Location..."
                                inputProps={{ name:'locationId', className:''}}
                                onChange={(s) => this.handleLocationChange(s)}
                                onInputChange={this.handleRemoveLocation}
                            />  
                        </div>
                    </div>
                </div>
                 
                {this.props.eventStatusNotRequired!=='yes' && <div className="filter-category">
                    <div className="form-group">
                        <h4>{LBL_EVENT_STATUS}</h4>
                        <div className="form-group multisel_textbox">
                            <div className="form-group select-input skills" >
                                <CustomMultiSelect data={this.props.isEvent?eventStatusData:quotePageEventStatusData}  onChange={selected =>this.onEventStatusDataChange(selected,'event')} isTextBox={false}  needSelectAll={true} />
                            </div>
                        </div>
                    </div> 
                </div>} 

                {this.props.isListLayout===true && <div className="filter-category">
                    <div className="form-group">
                        <h4>{LBL_QUOTE_STATUS}</h4>
                        <div className="form-group multisel_textbox">
                            <div className="form-group select-input skills" >
                                <CustomMultiSelect data={this.props.isEvent?eventPageQuoteStatusData:quoteStatusData}  onChange={selected =>this.onEventStatusDataChange(selected,'quote')} isTextBox={false}  needSelectAll={true} />
                            </div>
                        </div>
                    </div> 
                </div>}

                {!this.props.isClientPage && this.props.cancelReasonsNotRequired!=='yes' && <div className="filter-category">
                    <div className="form-group">
                        <h4>{LBL_QUOTE_EVENT_CANCEL_REASONS}</h4>
                        <div className="form-group multisel_textbox">
                            <div className={this.state.enableCancelReason? "form-group select-input skills": "text-optional form-group select-input skills"}>
                                <CustomMultiSelect data={this.state.cancelReasonsData}  onChange={selected =>this.onCancelReasonDataChange(selected)} isTextBox={false}  needSelectAll={true} disableSelectAll={this.state.enableCancelReason?false:true}/>
                            </div>
                        </div>
                    </div> 
                </div> }

                {this.props.isListLayout===true && <div className="filter-category">
                    <div className="form-group">
                        <h4>{LBL_CREATED_COMPLETED_DATE}</h4> 
                        <div className="select-input">  
                            <select onChange={(e) => this.onSelectCCDate(e)} name="selCheckinCheckout" value={selDateType} >  
                                <option value="" >{LBL_SELECT}</option>
                                <option value='start' >{LBL_STARTED_DATE}</option>
                                <option value='completed' >{LBL_COMPLETED_DATE}</option> 
                                <option value='created' >{LBL_CREATED_DATE}</option> 
                            </select>                           
                        </div>
                    </div> 
                </div>}  
                
                {this.props.isListLayout===true && selDateType.length > 1 && <div className="filter-category">                   
                    <div className="row"> 
                        <div className="col-6 paddingTop6"> <h4>{LBL_DATE_FROM}</h4></div>
                        <div className="col-6 paddingTop6"> <h4>{LBL_DATE_TO}</h4></div>
                    </div>
                    <div className="form-group">
                        <div className="form-group"> 
                            <div className="row">
                                <div className="col-6">
                                    <div className="calendar-input">  
                                        <DatePicker 
                                            selected={selectedStartDate}
                                            onChange={selected => this.onStartDateChange(selected)}
                                            name="startDate"
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            dateFormat="dd/MM/yyyy"
                                            placeholderText="Select"
                                            //maxDate={new Date()}
                                            // minDate={new Date()}
                                            fixedHeight   
                                            disabled={!includeDate}
                                            popperPlacement="top-start"       
                                        />
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="calendar-input ">  
                                        <DatePicker 
                                            selected={selectedEndDate}
                                            onChange={selected => this.onEndDateChange(selected)}
                                            name="endDate"
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            dateFormat="dd/MM/yyyy"
                                            placeholderText="Select"
                                            //maxDate={new Date()}
                                            minDate={new Date(selectedStartDate)}
                                            fixedHeight     
                                            disabled={!includeDate}
                                            popperPlacement="top-start"         
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>}

                {this.props.isListLayout===true && selDateType.length > 1 && <div className="filter-category">
                        <div className="form-group">                   
                            <div className="row"> 
                                <div className="col-6">
                                </div>
                            </div>
                        </div>
                    </div>}
                    {this.props.isListLayout===true && selDateType.length > 1 && <div className="filter-category">
                        <div className="form-group">                   
                            <div className="row"> 
                                <div className="col-6">
                                </div>
                            </div>
                        </div>
                    </div>}

                {this.props.hideShiftTimeChangeRequests!=='yes' && <div className="filter-category">
                    <div className="form-group">                   
                        <div className="row"> 
                            <div className="col-8"> <h4>
                                <div className="custom-checkbox" > 
                                    <input type="checkbox" id="shift_time_change_request" name="shift_time_change_request"  checked={this.state.shiftTimeChangeRequest}  onChange={e => this.onShiftTimeChangeRequestChecked(e)} />
                                    <label className="checkbox" htmlFor="shift_time_change_request" ></label>
                                    <label htmlFor="shift_time_change_request" > &nbsp; Show Shift Time Change Requests</label> 
                                </div></h4>
                            </div>
                        </div>
                    </div>
                </div>}

                {this.props.calledFrom==='shiftCalendar' && <div className="filter-category">
                    <div className="form-group">
                        <h4>{LBL_EVENT_STAFF_ASSIGNED_STATUS}</h4> 
                        <div className="select-input">  
                            <select onChange={(e) => this.onSelectStaffAssigned(e)} name="selStaffAssigned" value={selStaffAssigned} >  
                                <option value="" >{LBL_ALL}</option>
                                <option value='incomplete' >{LBL_INCOMPLETE}</option>
                                <option value='completed' >{LBL_COMPLETED}</option> 
                            </select>                           
                        </div>
                    </div> 
                </div>} 

                {/* TO ENABLE THE SCROLL SPACE FOR SHIFT STATUS DROPDOWN  */}
                <div style={{paddingTop:paddingTopPix}}></div>

                {/* <div className="filter-category">
                    <h4>PO Number</h4>
                    <div className="form-group">
                    <div className="form-group text-input">
                        <input type="text" />
                    </div>
                    </div>
                </div>
                <div className="filter-category">
                    <h4>Quote No</h4>
                    <div className="form-group">
                    <div className="form-group text-input">
                        <input type="text" />
                    </div>
                    </div>
                </div> */}
            </React.Fragment>
        )
    }

}

const mapStateToProps = (state) => { 
    return {
        filterClientsList: state.event.filterClientsList, 
        filterStatus: state.event.filterStatus,
        filterActivity: state.event.filterActivity,
        filterErrorData: state.event.filterErrorData,
        eventsFilterStatus: state.event.eventsFilterStatus,
        eventsFilterActivity: state.event.eventsFilterActivity,
        eventsFilterErrorData: state.event.eventsFilterErrorData,
        eventsFilterEventsList: state.event.eventsFilterEventsList,
        eventsFilterLocationsList: state.event.eventsFilterLocationsList,
        dashboardActionRequired: state.commons.fromActionRequired,
        filterAffiliatesList: state.event.filterAffiliatesList,        
        fromClientDashboardQuote: state.commons.fromClientDashboardQuote,        
        fromClientDashboardEvent: state.commons.fromClientDashboardEvent,        
        fromClientDashboardCompletedEvent: state.commons.fromClientDashboardCompletedEvent,
        fromDashboardShiftTimeChangeRequest: state.commons.fromDashboardShiftTimeChangeRequest,
        depActivity: state.afltDepartments.activity,
        departmentsList: state.afltDepartments.departmentsList,
        serverTimeList: state.serverTimeList.serverTimeList,
        serverTimeListActivity : state.serverTimeList.serverTimeListActivity,  

    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        filterClientsListAction:filterClientsListAction,  
        eventsFilterEventsListAction:eventsFilterEventsListAction,   
        eventsFilterLocationsListAction:eventsFilterLocationsListAction,
        fromActionRequired:fromActionRequired,
        filterAffiliatesListAction:filterAffiliatesListAction,  
        fromClientDashboardQuotes:fromClientDashboardQuotes,  
        fromClientDashboardEventsFun:fromClientDashboardEvents,  
        fromClientDashboardCompletedEvents:fromClientDashboardCompletedEvents,
        fromDashboardShiftTimeChange:fromDashboardShiftTimeChange,  
        aflt_departmentsListAction:aflt_departmentsListAction,
        serverTimeAction:serverTimeAction  
    },dispatch);
}

export default connect(mapStateToProps,mapDispatchToProps)(FilterEvent);
